import * as ActionTypes from "constants/ActionTypes";
import { combineReducers } from "redux";

function muted(state = false, action) {
  switch (action.type) {
    case ActionTypes.SET_VOLUME_MUTED:
      return action.value;
    case ActionTypes.TOGGLE_VOLUME_MUTED:
      return !state;
    default:
      return state;
  }
}

function initiallyMuted(state = false, action) {
  switch (action.type) {
    case ActionTypes.SET_INITIALLY_MUTED:
      return action.value;
    case ActionTypes.SET_VOLUME_MUTED:
      if (!action.value) {
        // not muted
        return false;
      }
      return state;
    case ActionTypes.TOGGLE_VOLUME_MUTED:
      return false;
    default:
      return state;
  }
}

function wasInitiallyMuted(state = false, action) {
  switch (action.type) {
    case ActionTypes.SET_INITIALLY_MUTED:
      return action.value;
    default:
      return state;
  }
}

function unmutedVolumeFromUIActivity(state = false, action) {
  switch (action.type) {
    case ActionTypes.UNMUTE_VOLUME_FROM_UI_ACTIVITY:
      return true;
    default:
      return state;
  }
}
export default combineReducers({
  initiallyMuted,
  muted,
  unmutedVolumeFromUIActivity,
  wasInitiallyMuted,
});
